// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetRequestFormByIdRequestModel from '../../model/get-request-form-by-id-request-model';
import GetRequestFormByIdRequestDTO from '../dto/get-request-form-by-id-request-dto';
import dtoSchema from '../schemas/get-request-form-by-id-request-schema';

export default abstract class GetRequestFormByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetRequestFormByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetRequestFormByIdRequestDTO>): GetRequestFormByIdRequestModel;
  static toModel(dto: DeepPartial<GetRequestFormByIdRequestDTO> | undefined | null): GetRequestFormByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetRequestFormByIdRequestDTO> | undefined | null): GetRequestFormByIdRequestModel | undefined {
    return dto ? new GetRequestFormByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetRequestFormByIdRequestModel> | GetRequestFormByIdRequestModel): GetRequestFormByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetRequestFormByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetRequestFormByIdRequestModel, can not map to GetRequestFormByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
